/** Shared paths for attendance engine / operational onboarding gates. */

export const ATTENDANCE_SETUP_PATHS = ["/attendance/setup", "/attendance/setup-wizard"];
export const ATTENDANCE_CONFIGURATION_PATH = "/attendance/configuration";
export const ATTENDANCE_ONBOARDING_PATH = "/attendance/onboarding";

export function isAttendanceHub(pathname) {
  return pathname === "/attendance" || pathname === "/attendance/";
}

export function isAttendanceSetupPath(pathname) {
  return ATTENDANCE_SETUP_PATHS.some((p) => pathname === p || pathname.startsWith(`${p}/`));
}

export function pathAllowed(pathname, allowedPrefixes) {
  return allowedPrefixes.some(
    (p) => pathname === p || pathname.startsWith(`${p}/`)
  );
}

/** Routes allowed while operational onboarding is in progress (admin). */
export const OPERATIONAL_ALLOWED_PREFIXES = [
  ...ATTENDANCE_SETUP_PATHS,
  ATTENDANCE_CONFIGURATION_PATH,
  ATTENDANCE_ONBOARDING_PATH,
  "/attendance",
  "/attendance/shifts",
  "/attendance/roster",
  "/holiday-calendar",
  "/attendance/devices",
  "/attendance/source-config",
  "/attendance/policies",
];
